<template>
  <div class="goods-setting-selector">
    <span class="goods-title">添加商品</span>
    <draggable
      v-if="Array.isArray($$FormData.goodsList)"
      v-bind="{sort: true}"
      :list="$$FormData.goodsList"
      prevent-on-filter
      animation="200"
      filter=".ignore-drag"
      class="goods-list"
    >
      <transition-group>
        <div v-for="item in $$FormData.goodsList" :key="item.goods_id" class="item-goods">
          <img :src="item.goods_image" :alt="item.goods_name" class="goods-img" />
          <i class="ri-close-circle-fill del-icon" @click="handleDeleteGoods(item)"></i>
        </div>
        <div class="item-goods add ignore-drag" key="add-goods" @click="handleAddGoods">
          <i class="ri-add-line"></i>
        </div>
      </transition-group>
    </draggable>
    <div class="display-count">
      <span>展示商品数</span>
      <el-input-number v-model="displayGoodsCount" size="small" :min="selectedCount ? 1 : 0" :max="selectedCount || 1" :step="1" step-strictly :disabled="!selectedCount" />
      <p>已选{{ selectedCount }}个商品，按选择顺序展示，不可展示的商品由后续商品补位。</p>
    </div>
    <decor-goods-picker
      :show="goods_picker_show"
      :goods-api="goodsApi"
      :multiple-api="multipleApi"
      :default-data="$$FormData.goodsList"
      @confirm="handleGoodsPickerConfirm"
      @close="goods_picker_show = false"
    />
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import DecorGoodsPicker from '@/components/normal/DecorGoodsPicker'
import { api } from '~/ui-domain'
import { decorType } from '@/utils/decor-types'

export default {
  name: 'GoodsSettingSelector',
  components: { Draggable, DecorGoodsPicker },
  data() {
    return {
      goods_picker_show: false
    }
  },
  mounted() {
    this.initializeDisplayCount(this.selectedCount)
  },
  computed: {
    selectedCount() { return (this.$$FormData.goodsList || []).length },
    displayGoodsCount: {
      get() {
        const count = Number(this.$$FormData.display_goods_count)
        return Number.isInteger(count) && count > 0 ? Math.min(count, this.selectedCount) : this.selectedCount
      },
      set(value) {
        this.$set(this.$$FormData, 'display_goods_count', Number.isInteger(value) && value > 0 ? value : null)
      }
    },
    goodsPickerApi() {
      return decorType === 'admin'
        ? `${api.admin}/admin`
        : `${api.seller}/seller`
    },
    goodsApi() {
      return decorType === 'seller'
        ? `${this.goodsPickerApi}/shop-goods/decor-selector/goods`
        : `${this.goodsPickerApi}/goods/decor-selector/goods`
    },
    multipleApi() {
      if (decorType === 'seller') return this.goodsPickerApi + '/shop-goods/decor-selector/goods/@ids/details'
      return this.goodsPickerApi + '/goods/@ids/details'
    }
  },
  methods: {
    initializeDisplayCount(count) {
      const configured = Number(this.$$FormData.display_goods_count)
      if ((!Number.isInteger(configured) || configured <= 0) && count > 0) {
        this.$set(this.$$FormData, 'display_goods_count', count)
      }
    },
    /**
     * 添加商品
     */
    handleAddGoods() {
      this.goods_picker_show = true
    },
    /**
     * 删除商品
     * @param item
     */
    handleDeleteGoods(item) {
      const index = this.$$FormData.goodsList.findIndex(_item => _item.goods_id === item.goods_id)
      this.$$FormData.goodsList.splice(index, 1)
    },
    /**
     * 商品选择器确定
     * @param items
     */
    handleGoodsPickerConfirm(items) {
      items = JSON.parse(JSON.stringify(items))
      this.$$FormData.goodsList = items
      // 每次确认选品都按最新选择数量更新，之后仍可手动调整展示数。
      this.$set(this.$$FormData, 'display_goods_count', items.length || null)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-setting-selector {
  .display-count { margin-top: 16px; padding-top: 16px; border-top: 1px solid #ebeef5; }
  .display-count > span { margin-right: 16px; }
  .display-count p { margin: 10px 0 0; color: #969799; font-size: 12px; line-height: 20px; }
  width: 100%;
  padding: 12px 16px;
  box-sizing: border-box;
  background-color: #ffffff;
  .goods-title {
    width: 100%;
    height: 30px;
    font-size: 14px;
    color: #969799;
    line-height: 18px;
    white-space: nowrap;
  }
  .goods-list {
    padding: 12px 16px;
    background-color: #f7f8fa;
    box-sizing: border-box;
    &>span {
      display: flex;
      flex-wrap: wrap;
    }
    .item-goods {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 50px;
      height: 50px;
      padding: 0;
      margin: 5px 10px 5px 0;
      border: none;
      box-shadow: 0 0 4px 0 rgba(10,42,97,0.2);
      color: #155bd4;
      font-size: 14px;
      background-color: #ffffff;
      border-radius: 2px;
      cursor: move;
      &.add {
        cursor: pointer;
      }
      &:hover {
        .del-icon {
          display: block;
        }
        &:not(.add)::after {
          display: block;
        }
      }
      &::after {
        display: none;
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid #155bd4;
        border-radius: 2px;
        z-index: 1;
        pointer-events: none;
      }
      .goods-img {
        display: block;
        width: 100%;
        height: 100%;
        margin: 0;
        overflow: hidden;
      }
      .del-icon {
        display: none;
        position: absolute;
        z-index: 2;
        top: -10px;
        right: -10px;
        border-radius: 50%;
        color: #bbbbbb;
        font-size: 20px;
        background-color: #ffffff;
        line-height: normal;
        cursor: pointer;
      }
    }
  }
}
</style>
